import React from "react"
import styled from "styled-components"

let Input = styled.input`
  outline: none;
  background-color: white;
  font: inherit;
  padding: 0px 10px;
  display: block;
  width: 100%;
  box-sizing: border-box;
  border: none;
  border: 1px solid #949494;
  border-radius: 8px;
  height: 40px;
  box-shadow: none;
  overflow: visible;
  margin-top: 10px;
  color: inherit;
  cursor: text;
  &:focus,
  &:active {
    box-shadow: none;
    //border: solid 0.5px #11adf3;
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #ccc !important;
    font-weight: 300;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #ccc !important;
    font-weight: 300;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #ccc !important;
    font-weight: 300;
  }
`

const Textbox = (props) => {
  if (props.withoutBorder) {
    Input = styled(Input)`
      border: none;
    `;
  }

  return (
    <Input
      innerRef={props.reference}
      onKeyPress={props.onKeyPress}
      className={`${props.className} ${props.value ? "fg-input-valid" : ""}`}
      readOnly={props.readOnly}
      onBlur={props.onBlur}
      onChange={props.update}
      maxLength={props.maxlength}
      {...props}
    />
  )
}

export default Textbox
